import svgSprite from "@repo/fika-design-system/sprite.svg?raw"
import { MetaProvider } from "@solidjs/meta"
import { QueryClient, QueryClientProvider } from "@tanstack/solid-query"
import type { ParentProps } from "solid-js"
import "./root-layout.css"
import { FeatureFlagsProvider } from "@/context/feature-flags-provider"
import { GraphQLProvider } from "@/context/graphql-provider"
import { I18nProvider } from "@/context/i18n-provider"
import { SessionProvider } from "@/context/session-provider"
import { SWProvider } from "@/lib/sw-provider"
import { VersionProvider } from "@/lib/version-provider"

const queryClient = new QueryClient()

export function RootLayout(props: ParentProps) {
  return (
    <MetaProvider>
      <SWProvider>
        <VersionProvider>
          <GraphQLProvider>
            <QueryClientProvider client={queryClient}>
              <FeatureFlagsProvider>
                <SessionProvider>
                  <I18nProvider>
                    <div innerHTML={svgSprite} style="display: none" />
                    {props.children}
                  </I18nProvider>
                </SessionProvider>
              </FeatureFlagsProvider>
            </QueryClientProvider>
          </GraphQLProvider>
        </VersionProvider>
      </SWProvider>
    </MetaProvider>
  )
}
